import moment from "moment";

export const formatCurrency = (value: number | undefined) => {
  if (value) {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }
  return "";
};

export const formatDate = (value: any) => {
  return moment(value).format("MM/DD/yyyy");
};

export const formatDateAsString = (value: any) => {
  return moment(value).format("MM/DD/yyyy").toString();
};

export const formatBoolean = (value: boolean) => {
  return value === true ? "true" : "false";
};

export const convertToMB = (value: number | undefined) => {
  let megs = 0;

  if (value) {
    megs = value / 1024 / 1024;
  }
  return megs.toFixed(2);
};
